var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-app"},[(!_vm.isPlainRoute)?_c('home-header-section'):_vm._e(),_c('div',{attrs:{"id":"maincontent"}},[_c('home-container')],1),(!_vm.isPlainRoute && !_vm.isNotFoundRoute)?_c('footer-section'):_vm._e(),_c('application-status-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }